var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleMobilePlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 49,
  viewBox: "0 0 49 49",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M24.5 0C38.031 0 49 10.969 49 24.5S38.031 49 24.5 49 0 38.031 0 24.5 10.969 0 24.5 0m0 2.042C12.097 2.042 2.042 12.097 2.042 24.5S12.097 46.958 24.5 46.958 46.958 36.903 46.958 24.5 36.903 2.042 24.5 2.042m0 2.041c11.276 0 20.417 9.141 20.417 20.417S35.776 44.917 24.5 44.917 4.083 35.776 4.083 24.5 13.224 4.083 24.5 4.083m-5.444 12.25v16.334l13.61-8.167z"
})));
export default SvgGoogleMobilePlay;